import { injectLocal, provideLocal } from '@vueuse/core';
import { usePageData } from '@composables/usePageData';

/**
 *
 * @type {import('vue').InjectionKey<ExperimentationContext>}
 */
export const USE_EXPERIMENTS_KEY_REPOSITORY = Symbol.for('USE_EXPERIMENTS_KEY_REPOSITORY');

/**
 * * Provide the experiment flags and ids context to the application
 *
 * @description
 * Some features need to be conditionally enabled based on the experiments configuration,
 * which is provided by the server not only by killswitches but also by experiment ids.
 * This composable provides the experiment flags and ids to the application.
 */
export const useExperimentsProvide = () => {
  const { experimentFlags, experimentIds } = usePageData();

  provideLocal(USE_EXPERIMENTS_KEY_REPOSITORY, {
    experimentFlags,
    experimentIds: new Set(experimentIds),
  });
};

/**
 * * Get the experiment flags and ids context
 *
 * @description
 * Some features need to be conditionally enabled based on the experiments configuration.
 * @see useExperimentsProvide
 */
export const useExperiments = () => {
  const experiments = injectLocal(USE_EXPERIMENTS_KEY_REPOSITORY);
  if (!experiments) {
    throw new Error('useExperiments must be used within a useExperimentsProvide');
  }
  return experiments;
};
